var React = require('react');

function Ic16pxNextWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.29588 3.78265L12.1272 6.70525L13.4922 7.98762L12.1272 9.26998L9.29587 12.1926C8.11615 13.3855 9.88574 15.2345 11.0655 13.9819L16.1383 8.91212C16.6102 8.43496 16.6102 7.59993 16.1383 7.06312L11.0655 1.9933C9.88574 0.800398 8.11615 2.58975 9.29588 3.78265Z","fill":"white"}));
}

Ic16pxNextWhite.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Ic16pxNextWhite;

Ic16pxNextWhite.default = Ic16pxNextWhite;
